import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layout/fullLayout/loadable/loadable";
import { OOPSError } from "../views/authentication/OopsError";
import { ProtectedRoute } from "./ProtectedRoutes";
import { PublicRoute } from "./PublicRoute";

import { customerRoutes } from "../views/customers/customer.router";
import { leadRoutes } from "../views/leads/Leads.router";
import { opportunityRoutes } from "../views/opportunites/opportunity.router";
import { profileRoutes } from "../views/Profile/profile.router";
import { securityRoutes } from "../views/Security/security.router";
import { templateRoutes } from "../views/Templates/template.router";
import { dashboardRoutes } from "../views/dashboard/dashboard.router";
import { envConfigRoutes } from "../views/EnvConfig/EnvConfig.router";
import { Chat } from "../views/Chat";
import { componyInformationRoutes } from "../views/CompanyInformation/CompanyInformation.router";
import { inventoryRoutes } from "../views/Inventory/router";
import { categoryRoutes } from "../views/category/category.router";
import { bookingRoutes } from "../views/bookingList/booking.router";
import { categoryTypeRoutes } from "../views/categoryType/categoryType.router";
import { foodMenuRoutes } from "../views/foodMenu/food.router";
import { ReviewReplyRoutes } from "../views/ReviewReply/ReviewReply.router";
//import { marketCampaign } from "../views/MarketCampaign/router";
import { zoneRoutes } from "../views/userZone/userZone.router";
import { whatsAppQRRoutes } from "../views/whatsAppQR/whatsAppQR.router";
//import { marketCampaignRoutes } from "../views/marketingCampaign/MarketCampaign.router";
import { OtherUserLogin } from "../views/authentication/OtherUserLogin";
import { customerTypeRoutes, eventTypeRoutes } from "../views/manageTypes/manageTypeRouter";
import { CompanyOutletRoutes } from "../views/companyOutlet/companyOutlet.router";
import { eventRoutes } from "../views/Events/Event.router";
import { auctionsRoutes } from "../views/auctions/Auction.router";
import { OnlineDsaRoutes } from "../views/OnlineDsa/OnlineDsa.router";
import { HelpingLeadsRoutes } from "../views/HelpingLeads/LeadsfromWebsite.router";
import { partnerRoutes } from "../views/partners/partner.routes";
import { crossroadsLeadsRoutes } from "../views/CrossroadsLeads/crossroadsleads.routes"
import { callingRoutes } from "../views/calling/calling.routes";
import { chatbotRoutes } from "../views/Chatbot/chatbot.router";
import { campaignRoutes } from "../views/campaign/campaign.route";
import { apiKeyRoutes } from "../views/apikey/apikey.route"
import { rsaPackageRoutes } from "../views/rsaPackages/rsaPackages.route"
import { promocodeRoutes } from "../views/promocode/promocode.routes"
import { dispositionRoutes } from "../views/disposition/disposition.routes"
import { campaignReportsRoutes } from "../views/CrossroadsLeads/CampaignReports/campaignReports.routes"
import { CustomerConnectionDetailsRoutes } from "../views/CustomerConnectionDetails/CustomerConnectionDetailsRoutes"
import { ComplaintReportRoutes } from "../views/ComplaintReport/CustomerReportRoutes";
import { complaintsRoutes } from "../views/complaints/Assigncomplaints/complaints.routes";
import { dealRoutes } from "../views/Deals/deal.router";
import { partnerWalletRoutes } from "../views/partnerWallet/partnerWallet.routes";
import { paInsuranceRoutes } from "../views/paInsurance/paInsurance.routes";
import { manipalSignalWalletRoutes } from "../views/manipalSignalWallet/manipalSignalWallet.routes";
import { manageMembershipRoutes } from "../views/manageMembership/manageMembership.routes";
import { mechanicListRoutes } from "../views/mechanicList/mechanicList.routes";
import { lawyeredRoutes } from "../views/lawyered/lawyered.routes";

/* ***Layouts**** */
/**
 * Lazy loads the FullLayout component.
 *
 * This approach is used to split the code and load the FullLayout component only when it is needed.
 * It helps in reducing the initial load time of the application by deferring the loading of the FullLayout component
 * until it is actually required. This can improve the performance and user experience of the application.
 *
 * The `Loadable` function is used to handle the loading state and potential errors during the loading process.
 * The `lazy` function from React is used to dynamically import the FullLayout component.
 */

const FullLayout = Loadable(
	lazy(() =>
		import("../layout/fullLayout/FullLayout").then(({ FullLayout }) => ({
			default: FullLayout,
		}))
	)
);
const BlankLayout = Loadable(
	lazy(() => import("../layout/blankLayout/BlankLayout"))
);
/* ***End Layouts**** */

const Error = Loadable(
	lazy(() =>
		import("../views/authentication/Error").then(({ Error }) => ({
			default: Error,
		}))
	)
);

/* ****Pages***** */

const Login = Loadable(
	lazy(() =>
		import("../views/authentication/Login").then(({ Login }) => ({
			default: Login,
		}))
	)
);
const AccessDenied = Loadable(
	lazy(() =>
		import("../views/authentication/AccessDenied").then(({ AccessDenied }) => ({
			default: AccessDenied,
		}))
	)
);

const PublicManageLead = Loadable(
	lazy(() =>
		import("../views/PublicLead/publicManageLead").then(
			({ PublicManageLead }) => ({
				default: PublicManageLead,
			})
		)
	)
);

const ForgotPassword = Loadable(
	lazy(() =>
		import("../views/authentication/ForgotPassword").then(
			({ ForgotPassword }) => ({
				default: ForgotPassword,
			})
		)
	)
);

// const OnlineDSA = Loadable(
// 	lazy(() =>
// 		import("../views/OnlineDSA/OnlineDSA").then(({ OnlineDSA }) => ({
// 			default: OnlineDSA,
// 		}))
// 	)
// );
export const Router = [
	{
		path: "/",
		element: (
			<ProtectedRoute>
				<FullLayout />
			</ProtectedRoute>
		),
		children: [
			{
				path: "/",
				exact: true,
				element: (
					<Navigate
						to="/dashboard"
						replace
					/>
				),
			},

			// ------------- opportunites ----------------------------

			{ path: "access", element: <AccessDenied /> },
			{ path: "error", element: <OOPSError /> },
			{ path: "*", element: <Navigate to="/auth/404" /> },
		]
			.concat(dashboardRoutes)
			.concat(leadRoutes)
			.concat(customerRoutes)
			.concat(opportunityRoutes)
			.concat(profileRoutes)
			.concat(securityRoutes)
			.concat(templateRoutes)
			.concat(envConfigRoutes)
			.concat(componyInformationRoutes)
			.concat(inventoryRoutes)
			.concat(categoryRoutes)
			.concat(bookingRoutes)
			.concat(categoryTypeRoutes)
			.concat(foodMenuRoutes)
			.concat(ReviewReplyRoutes)
			//.concat(marketCampaign)
			.concat(zoneRoutes)
			.concat(whatsAppQRRoutes)
			//.concat(marketCampaignRoutes)
			.concat(customerTypeRoutes)
			.concat(eventTypeRoutes)
			.concat(CompanyOutletRoutes)
			.concat(eventRoutes)
			.concat(auctionsRoutes)
			.concat(HelpingLeadsRoutes)
			.concat(OnlineDsaRoutes)
			.concat(partnerRoutes)
			.concat(crossroadsLeadsRoutes)
			.concat(callingRoutes)
			.concat(chatbotRoutes)
			.concat(campaignRoutes)
			.concat(apiKeyRoutes)
			.concat(rsaPackageRoutes)
			.concat(promocodeRoutes)
			.concat(dispositionRoutes)
			.concat(campaignReportsRoutes)
			.concat(CustomerConnectionDetailsRoutes)
			.concat(ComplaintReportRoutes)
			.concat(complaintsRoutes)
			.concat(dealRoutes)
			.concat(partnerWalletRoutes)
			.concat(paInsuranceRoutes)
			.concat(manipalSignalWalletRoutes)
			.concat(manageMembershipRoutes)
			.concat(mechanicListRoutes)
			.concat(lawyeredRoutes),


	},

	// --------------------------------TASK ROUTING----------------------------------------------

	{
		path: "/auth",
		element: (
			<PublicRoute>
				<BlankLayout />
			</PublicRoute>
		),
		children: [
			{ path: "404", element: <Error /> },
			{ path: "login", element: <Login /> },
			{ path: "reset-password", element: <ForgotPassword /> },
			{ path: "*", element: <Navigate to="/auth/404" /> },
		],
	},
	{
		path: "/other",
		element: <BlankLayout />,
		children: [
			{ path: "user-access", element: <OtherUserLogin /> },
			{ path: "404", element: <Error /> },
			{ path: "login", element: <Login /> },
			{ path: "reset-password", element: <ForgotPassword /> },
			{ path: "*", element: <Navigate to="/auth/404" /> },
		],
	},
	{
		path: "/student-lead-form",
		element: <PublicManageLead />,
	},
	{ path: "/chat", element: <Chat /> },
];
